<template>
    <div class="order_detial no-trans" v-loading="loading">
        <div class="order_titles">{{ mobile_view ? '评价订单' : '查看订单详情' }}</div>
        <div class="order_derial_box">
             
             
            <div class="order_item">
                <div class="item_titles">
                    <div class="order_lefts">
                        <div class="order_time">{{ order_detial.created_at }} </div>
                        <div class="order_no">订单号：{{ order_detial.order_sn }}</div>
                    </div>
                </div>
                <div class="order_info_shop">
                    <div class="shop_list">
                        <div class="shop_item">
                            <div class="shop_left">
                                <div class="shop_img">
                                    <img v-if="!mobile_view" src="@/assets/img/index/legal/bg1.png" alt="">
                                    <img v-else-if="(order_detial.pro || {}).thumb" :src="order_detial.pro.thumb" alt="">
                                    <i v-else class="el-icon-document" aria-hidden="true"></i>
                                </div>
                                <div class="shop_title">{{ (order_detial.pro||{}).title }}</div>
                            </div>
                            <div class="shop_right">
                                <div class="shop_price1">{{(order_detial.pro||{}).price}}元</div>
                                <div class="shop_num">X1</div>
                                <div class="shop_price2">{{(order_detial.pro||{}).price}}元</div>
                            </div>
                        </div>
                    </div>
                    <div class="order_price">
                        <div class="btns_lefts">
                            <div class="text1">
                                共
                                <span>1</span>
                                个商品
                            </div>
                            <div class="text2">
                                合计金额
                                <span> {{(order_detial.pro||{}).price}}</span>
                                元
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="pj_box">
                <div class="pj_tops">
                    <div class="texts1">总体评价</div>
                    <div class="pj_nums">
                        <template v-if="!mobile_view">
                        <img src="@/assets/img/user_info/user_order/xx_1.png" alt="" v-for="(item,index) in 5" v-if="(index+1)<=nums" @click="handle_nums(index)">
                        <img src="@/assets/img/user_info/user_order/xx_2.png" alt="" v-for="(item,index) in 5" v-if="(index+1)>nums" @click="handle_nums(index)">
                        </template>
                        <div v-else class="mobile_rating" role="group" aria-label="总体评价评分">
                            <button type="button" v-for="score in 5" :key="score" :aria-label="score + '星'" :aria-pressed="String(nums === score)" @click="handle_nums(score - 1)">
                                <i :class="score <= nums ? 'el-icon-star-on' : 'el-icon-star-off'" aria-hidden="true"></i>
                            </button>
                            <span class="rating_value" aria-live="polite">{{ nums ? nums + '星' : '未评分' }}</span>
                        </div>
                    </div>
                </div>
                <div class="pj_boms">
                    <label v-if="mobile_view" for="order_review_content">评价内容</label>
                    <textarea id="order_review_content" :placeholder="mobile_view ? '请分享您对本次服务的评价' : '请输入…'" aria-label="评价内容" v-model="texts" ></textarea>
                </div>
            </div>
            <div class="order_btns">
                <button v-if="mobile_view" type="button" class="mobile_review_submit" :disabled="loading" @click="handle_end">{{ loading ? '提交中…' : '发表评价' }}</button>
                <div v-else class="btns1" @click="handle_end">发表评价</div>
              
            </div>
        </div>

    </div>
</template>
<script>
import { mapState } from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            tyle_ac: 0,
            order_detial:{},
            texts:'',
            nums:0

        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_detial()

    },
    methods: {
        get_detial(){
            this.loading = true
            this.$api("myOrderDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('订单详情',res)
                if (res.code == 1) {
                    this.order_detial=res.data

                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_nums(index){
            console.log('星星',index+1)
            this.nums=index+1
        },
        handle_end(){
            if (this.loading) return
            if(!this.texts){
                alertErr('请输入评价内容')
                return
            }
            this.loading = true
            this.$api("comment", {
                order_id:this.$route.query.id,
                level:this.nums,
                content:this.texts,
			}, "post").then((res) => {
                this.loading = false
                console.log('订单详情',res)
                if (res.code == 1) {
                    this.$router.back()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        


    },

}
</script>
<style scoped lang="less">
.order_detial {
    .order_titles {
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }

    .order_derial_box {
        margin-top: 24px;
        padding: 24px;
        background: #FFFFFF;

     

        .order_item {
            // width: 1132px;
            min-height: 260px;
            margin-top: 24px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;

            .item_titles {
                // width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;

                .order_lefts {
                    display: flex;
                    align-items: center;

                    .order_time {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                        margin-right: 20px;
                    }

                    .order_no {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #333333;
                    }
                }

                .order_rights {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }

            .order_info_shop {
                padding: 0 24px;
                padding-top: 24px;

                .shop_list {

                    border-bottom: 1px solid #E5E5E5;

                    .shop_item {
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .shop_left {
                            display: flex;
                            align-items: center;

                            .shop_img {
                                width: 104px;
                                height: 104px;

                                img {
                                    width: 104px;
                                    height: 104px;
                                }
                            }

                            .shop_title {
                                padding-left: 24px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                            }
                        }

                        .shop_right {
                            display: flex;
                            align-items: center;

                            .shop_price1 {
                                width: 150px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;

                            }

                            .shop_num {
                                width: 100px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                            }

                            .shop_price2 {
                                width: 150px;
                                text-align: left;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;


                            }
                        }
                    }
                }

                .order_price {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    height: 64px;

                    .btns_lefts {
                        display: flex;
                        align-items: center;

                        .text1 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;

                            span {
                                color: #377CFD;
                                font-weight: bold;
                            }
                        }

                        .text2 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                            margin-left: 20px;
                            span {
                                color: #377CFD;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
        .pj_box{
            width: 1132px;
            height: 192px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #E5E5E5;
            margin-top: 24px;
            .pj_tops{
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                padding: 0 24px;
                display: flex;
                align-items: center;
                .texts1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;

                }
                .pj_nums{
                    padding-left: 20px;
                    img{
                        width: 21px;
                        margin-right: 16px;
                        cursor: pointer;
                    }
                }

            }
            .pj_boms{
                padding: 16px 24px;
                textarea{
                    width: 100%;
                    height: 120px;
                }
            }
        }
        .order_btns{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 32px;
            .btns1{
                width: 320px;
                height: 48px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 48px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
            }
          
        }

    }



}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .order_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .order_detial.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .order_detial.no-trans .order_derial_box {
        margin-top: 16px;
        padding: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item {
        min-height: 0;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles {
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_lefts .order_time {
        font-size: 14px;
        margin-right: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_lefts .order_no {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .order_item .item_titles .order_rights {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop {
        padding: 0 16px;
        padding-top: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item {
        margin-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_left .shop_img {
        width: 104px;
        min-height: 0;
        height: auto;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_left .shop_img img {
        width: 104px;
        min-height: 0;
        height: auto;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_left .shop_title {
        padding-left: 16px;
        font-size: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_right {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_right .shop_price1 {
        width: 150px;
        font-size: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_right .shop_num {
        width: 100px;
        font-size: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .shop_list .shop_item .shop_right .shop_price2 {
        width: 150px;
        font-size: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .order_price {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 44px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .order_price .btns_lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .order_price .btns_lefts .text1 {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .order_item .order_info_shop .order_price .btns_lefts .text2 {
        font-size: 14px;
        margin-left: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 44px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .texts1 {
        font-size: 14px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .pj_nums {
        padding-left: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_tops .pj_nums img {
        width: 21px;
        margin-right: 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_boms {
        padding: 16px 16px;
    }
    .order_detial.no-trans .order_derial_box .pj_box .pj_boms textarea {
        min-height: 0;
        height: auto;
    }
    .order_detial.no-trans .order_derial_box .order_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .order_detial.no-trans .order_derial_box .order_btns .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
@media (max-width: 1024px) {
    .order_detial.no-trans {
        background: #fff;
        .order_titles { height: auto; min-height: 48px; padding: 12px 16px; font-size: 18px; line-height: 26px; }
        .order_derial_box {
            padding: 0 16px 24px; margin: 0;
            .order_item {
                width: 100%; min-height: 0; margin: 0; border: 1px solid #e5eaf1; border-radius: 6px; overflow: hidden;
                .item_titles {
                    height: auto; padding: 12px; border: 0; background: #f5f7fb;
                    .order_lefts { display: block; min-width: 0; }
                    .order_time, .order_no { margin: 0; font-size: 13px; line-height: 22px; color: #748092; overflow-wrap: anywhere; }
                }
                .order_info_shop {
                    padding: 14px 12px;
                    .shop_list { border: 0; padding: 0; }
                    .shop_list .shop_item {
                        display: block; margin: 0;
                        .shop_left { display: flex; flex-wrap: nowrap; align-items: flex-start; gap: 10px; width: 100%; }
                        .shop_left .shop_img { display: flex; align-items: center; justify-content: center; flex: 0 0 64px; width: 64px; height: 64px; border-radius: 4px; overflow: hidden; background: #f3f6fa; }
                        .shop_left .shop_img img { display: block; width: 64px; height: 64px; object-fit: cover; }
                        .shop_left .shop_img i { font-size: 28px; color: #9aacc5; }
                        .shop_left .shop_title { flex: 1; min-width: 0; padding: 0; font-size: 15px; line-height: 24px; overflow-wrap: anywhere; }
                        .shop_right { display: flex; flex-wrap: wrap; justify-content: flex-end; width: 100%; padding-top: 8px; gap: 6px 12px; }
                        .shop_right .shop_price1, .shop_right .shop_num { width: auto; font-size: 13px; line-height: 22px; color: #748092; overflow-wrap: anywhere; }
                        .shop_right .shop_price2 { display: none; }
                    }
                    .order_price {
                        height: auto; margin-top: 12px; padding-top: 12px; border-top: 1px solid #edf0f5;
                        .btns_lefts { display: flex; align-items: baseline; justify-content: space-between; flex-wrap: wrap; gap: 4px 8px; width: 100%; }
                        .btns_lefts .text1, .btns_lefts .text2 { margin: 0; font-size: 13px; line-height: 24px; overflow-wrap: anywhere; }
                        .btns_lefts .text2 span { font-size: 19px; line-height: 28px; }
                    }
                }
            }
            .pj_box {
                margin-top: 24px; border: 0; background: #fff;
                .pj_tops { display: block; height: auto; padding: 0; border: 0; background: #fff; }
                .pj_tops .texts1 { font-size: 16px; line-height: 26px; font-weight: 600; }
                .pj_tops .pj_nums { padding: 8px 0 0; }
                .mobile_rating { display: flex; align-items: center; flex-wrap: wrap; gap: 0; }
                .mobile_rating button { display: flex; align-items: center; justify-content: center; flex: 0 0 44px; width: 44px; height: 44px; padding: 0; border: 0; background: transparent; cursor: pointer; }
                .mobile_rating button i { font-size: 30px; color: #e6aa37; }
                .rating_value { padding-left: 6px; color: #87909d; font-size: 13px; line-height: 22px; }
                .pj_boms { padding: 18px 0 0; }
                .pj_boms label { display: block; margin-bottom: 10px; font-size: 16px; line-height: 26px; font-weight: 600; }
                .pj_boms textarea { display: block; box-sizing: border-box; width: 100%; min-height: 176px; height: 176px; padding: 12px; border: 1px solid #dfe5ee; border-radius: 4px; background: #f8fafc; color: #43526a; font-family: inherit; font-size: 16px; line-height: 27px; resize: vertical; }
                .pj_boms textarea:focus { outline: 0; border-color: #377cfd; background: #fff; box-shadow: 0 0 0 2px rgba(55, 124, 253, .1); }
            }
            .order_btns { padding-top: 20px; }
            .mobile_review_submit { width: 100%; min-height: 46px; padding: 10px 16px; border: 0; border-radius: 4px; background: #377cfd; color: #fff; font-size: 16px; line-height: 26px; cursor: pointer; }
            .mobile_review_submit:disabled { opacity: .6; cursor: wait; }
            .mobile_review_submit:focus-visible, .mobile_rating button:focus-visible { outline: 2px solid #273a8e; outline-offset: 2px; }
        }
    }
}
</style>
